import Field from '../Field'
import remove from 'lodash/remove'
import cloneDeep from 'lodash/cloneDeep'

export default class extends Field {
  constructor (initial) {
    super(typeof initial === 'undefined' ? [] : initial)
  }

  static name = 'array'

  /** @inheritdoc */
  accessor (value) {
    if (!Array.isArray(value)) {
      value = [ value ]
    }

    remove(value, function (v) {
      return typeof v === 'undefined'
    })

    return value
  }

  /** @inheritdoc */
  mutator (value) {
    return this.accessor(value)
  }

  /** @inheritdoc */
  reset () {
    this._current = cloneDeep(this._default)
  }
}
